/*
 * Modal Messages
 *
 * This contains all the text for the Modal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.modal';

export default defineMessages({
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close dialog',
  },
});
